@if(profile){
    <div class="grid">
        <div class="col-12">
            <h3 class="m-0" translate>company_summary</h3>
        </div>
        <div class="col-12">
            @if(profile.summary.length === 0){
            <p class="m-0" translate>no_data_available</p>
            }@else{
            <p class="m-0" *ngIf="profile.summary.length > 0">{{profile.summary}}</p>
            }
        </div>
    </div>
}